import { CSSObject } from '@chakra-ui/react';

export const FooterLink: CSSObject = {
  textTransform: 'capitalize',
  color: 'white',
  fontWeight: 'bold',
};
